import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Label } from '@primer/react';
import { PropTableValues } from '../../../src/components';
import { Link } from 'gatsby';
import ComponentLayout from '../../../src/layouts/component-layout';
import { TextVariants } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {CTABanner, Button} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CTABanner>
  <CTABanner.Heading>
    Where the most ambitious teams build great things
  </CTABanner.Heading>
  <CTABanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </CTABanner.Description>
  <CTABanner.ButtonGroup>
    <Button>Primary Action</Button>
    <Button>Secondary Action</Button>
  </CTABanner.ButtonGroup>
</CTABanner>
`}</code></pre>
    <h3>{`Alignment`}</h3>
    <p>{`The content alignment can be changed using the `}<inlineCode parentName="p">{`align`}</inlineCode>{` prop on the root `}<inlineCode parentName="p">{`CTABanner`}</inlineCode>{`. This can be configured to either `}<inlineCode parentName="p">{`start`}</inlineCode>{` or `}<inlineCode parentName="p">{`center`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CTABanner align="center">
  <CTABanner.Heading>
    Where the most ambitious teams build great things
  </CTABanner.Heading>
  <CTABanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </CTABanner.Description>
  <CTABanner.ButtonGroup>
    <Button>Primary Action</Button>
    <Button>Secondary Action</Button>
  </CTABanner.ButtonGroup>
</CTABanner>
`}</code></pre>
    <h3>{`Optional background image`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ThemeProvider colorMode="dark">
  <CTABanner
    backgroundImageSrc={{
      narrow:
        'https://github.com/user-attachments/assets/a28110fd-d019-41a4-8f80-b49ae8895708',
      regular:
        'https://github.com/user-attachments/assets/a28110fd-d019-41a4-8f80-b49ae8895708',
      wide: 'https://github.com/user-attachments/assets/a28110fd-d019-41a4-8f80-b49ae8895708',
    }}
    align="center"
    hasShadow={false}
  >
    <CTABanner.Heading>
      Where the most ambitious teams build great things
    </CTABanner.Heading>
    <CTABanner.Description variant="default">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
      ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
      elementum.
    </CTABanner.Description>
    <CTABanner.ButtonGroup>
      <Button>Primary Action</Button>
    </CTABanner.ButtonGroup>
  </CTABanner>
</ThemeProvider>
`}</code></pre>
    <h3>{`Optional background colors`}</h3>
    <p><inlineCode parentName="p">{`CTABanner`}</inlineCode>{` supports `}<inlineCode parentName="p">{`default`}</inlineCode>{`, `}<inlineCode parentName="p">{`subtle`}</inlineCode>{` and arbitrary `}<inlineCode parentName="p">{`background-color`}</inlineCode>{` values`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CTABanner backgroundColor="subtle" hasShadow={false}>
  <CTABanner.Heading>
    Where the most ambitious teams build great things
  </CTABanner.Heading>
  <CTABanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </CTABanner.Description>
  <CTABanner.ButtonGroup>
    <Button>Primary Action</Button>
  </CTABanner.ButtonGroup>
</CTABanner>
`}</code></pre>
    <h3>{`Optional border`}</h3>
    <p>{`A border can be provided using the `}<inlineCode parentName="p">{`hasBorder`}</inlineCode>{` prop on the root `}<inlineCode parentName="p">{`CTABanner`}</inlineCode>{`. This will render a border around the `}<inlineCode parentName="p">{`CTABanner`}</inlineCode>{` component giving further separation between the foreground and background. Especially when there is no shadow present on the background.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CTABanner hasBorder>
  <CTABanner.Heading>
    Where the most ambitious teams build great things
  </CTABanner.Heading>
  <CTABanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </CTABanner.Description>
  <CTABanner.ButtonGroup>
    <Button>Primary Action</Button>
    <Button>Secondary Action</Button>
  </CTABanner.ButtonGroup>
</CTABanner>
`}</code></pre>
    <h3>{`Optional background`}</h3>
    <p>{`A background can be removed using the `}<inlineCode parentName="p">{`hasBackground`}</inlineCode>{` prop on the root `}<inlineCode parentName="p">{`CTABanner`}</inlineCode>{`. This will render the `}<inlineCode parentName="p">{`CTABanner`}</inlineCode>{` component without a background allowing it to blend in with its parent.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CTABanner hasBackground={false} hasShadow={false}>
  <CTABanner.Heading>
    Where the most ambitious teams build great things
  </CTABanner.Heading>
  <CTABanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </CTABanner.Description>
  <CTABanner.ButtonGroup>
    <Button>Primary Action</Button>
    <Button>Secondary Action</Button>
  </CTABanner.ButtonGroup>
</CTABanner>
`}</code></pre>
    <h3>{`Remove shadow`}</h3>
    <p>{`The shadow can be removed using the `}<inlineCode parentName="p">{`hasShadow`}</inlineCode>{` prop. This will render the component without the background shadow.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CTABanner hasShadow={false}>
  <CTABanner.Heading>
    Where the most ambitious teams build great things
  </CTABanner.Heading>
  <CTABanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </CTABanner.Description>
  <CTABanner.ButtonGroup>
    <Button>Primary Action</Button>
    <Button>Secondary Action</Button>
  </CTABanner.ButtonGroup>
</CTABanner>
`}</code></pre>
    <h3>{`Shadow color customization`}</h3>
    <p>{`The default shadow colors can be customized through their respective CSS variables.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const App = () => {
  const designTokenOverrides = \`
  .custom-colors[data-color-mode='dark'] {

    /*
     * Modify the value of these tokens.
     * Remember to apply light mode equivalents if you're enabling theme switching.
     */
    --brand-CTABanner-shadow-color-start: var(--base-color-scale-purple-5);
    --brand-CTABanner-shadow-color-end: var(--base-color-scale-red-5);

  }
\`
  return (
    <ThemeProvider colorMode="dark" className="custom-colors">
      <style>{designTokenOverrides}</style>
      <CTABanner>
        <CTABanner.Heading>
          Where the most ambitious teams build great things
        </CTABanner.Heading>
        <CTABanner.Description>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
          ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
          elementum.
        </CTABanner.Description>
        <CTABanner.ButtonGroup>
          <Button>Primary Action</Button>
          <Button>Secondary Action</Button>
        </CTABanner.ButtonGroup>
      </CTABanner>
    </ThemeProvider>
  )
}

render(<App />)
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`CTABanner `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to include within the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`align`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'start'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'center'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'start'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The horizontal positioning of content within the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['default', 'subtle', 'string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'default'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background color`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundImageSrc`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background image`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundImagePosition`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'center'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background position`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundImageSize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'cover'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background position size`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`hasBorder`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag used to provide a border to the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`hasShadow`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag used to provide a shadow to the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`hasBackground`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag used to add a background to the banner component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`CTABanner.Heading`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the `}<inlineCode parentName="td">{`CTABanner.Heading`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'h1'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'h2'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'h3'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'h4'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'h5'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'h6'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'h3'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading level`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'1'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'2'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'3'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'4'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'5'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'6'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'1'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Visual heading size, irrespective of level`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`CTABanner.Description`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variant`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={TextVariants} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'muted'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Specify alternative text appearance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3>{`CTABanner.ButtonGroup `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<Button>`}</inlineCode>{`, `}<inlineCode parentName="td">{`<Button>[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The buttons to be displayed within the group`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttonSize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'medium'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'large'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`large`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The size of the buttons in the group`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttonsAs`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'a'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'button'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'button'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets underlying HTML element for each button`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`id`}</inlineCode>{`, `}<inlineCode parentName="p">{`className`}</inlineCode>{` and `}<inlineCode parentName="p">{`ref`}</inlineCode>{` are forwarded by default to all children.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/components/BreakoutBanner" mdxType="Link">BreakoutBanner</Link>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      